import { render, staticRenderFns } from "./UserRemovalForm.vue?vue&type=template&id=7ab615aa&scoped=true&"
import script from "./UserRemovalForm.vue?vue&type=script&lang=js&"
export * from "./UserRemovalForm.vue?vue&type=script&lang=js&"
import style0 from "./UserRemovalForm.vue?vue&type=style&index=0&id=7ab615aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab615aa",
  null
  
)

export default component.exports